'use strict';

import { module } from '../app';
import * as _ from 'lodash';
import { stateData } from "./stateData";
import * as constantStrings from "../constants/constantStrings";

module.factory('AddReferringPhysicianDialogModel', ['Patient', 'modalService', 'environmentHelper', '$ionicLoading',
  function (Patient, modalService, environmentHelper, $ionicLoading) {
    function AddReferringPhysicianDialogModel(patient, checkIfStillOwningAndNotOffline) {
      let self = this;

      self.patient = patient;
      self.isAdded = false;
      self.requiredFields = ['LastName', 'FirstName', 'RefNum'];
      self.phoneNumberFields = ['OtherPhone', 'Phone', 'Fax'];
      self.isIOSDevice = environmentHelper.isIOSDevice();
      self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;
      self.isOwnershipLost = false;

      self.letterTypes = [
        {
          Code: 'P',
          Desc: 'Primary Letters'
        }, {
          Code: 'A',
          Desc: 'Alternate Letters'
        }, {
          Code: 'B',
          Desc: 'Primary And Alternate Letters'
        }];

      self.rp = {
        RefNum: '',
        LastName: '',
        FirstName: '',
        Suffix: '',
        Center: '',
        Street: '',
        City: '',
        State: '',
        Zip: '',
        Specialty: '',
        Phone: '',
        OtherPhone: '',
        Fax: '',
        FaxReport: false,
        RpLetterType: 'P',
        PatientLetterType: 'P',
        RecallLetterType: 'P',
        Udf1: '',
        Udf2: '',
        Notes: ''
      };

      self.rpCopy = _.cloneDeep(self.rp);

      self.statesList = stateData;
      self.citiesList = [];
      self.zipCodesList = [];
      self.showUdf1 = false;
      self.showUdf2 = false;

      self.init = function (modal, scope) {
        self.modalInstance = modal;
        self._scope = scope;

        if (self.rp.State && self.rp.City) {
          self.getCitiesList(self.patient.State);
        }
        self.getUdfDefs();
      };

      self.saveReferringPhysician = async function () {
        // Valid Data
        let missingFields = [];
        _.each(self.requiredFields, function (field) {
          if (!self.rp[field] || (self.rp[field] && self.rp[field].length == 0)) {
            missingFields.push(field);
          }
        });

        if (missingFields.length) {
          let msg = 'The following fields are required: ' + self.joinFields(missingFields) + '. Please correct your data.';
          modalService.showAlert(msg);
          return;
        }

        // Valid PhoneNumber
        var inValidPhoneNumberFields = [];
        _.each(self.phoneNumberFields, function (field) {
          if (self.rp[field] && !self.validatePhoneNumber(self.rp[field])) {
            inValidPhoneNumberFields.push(field);
          }
        });

        if (inValidPhoneNumberFields.length) {
          let msg = 'The following phone number fields are not valid: ' + self.joinFields(inValidPhoneNumberFields) + '. Please correct your data.';
          modalService.showAlert(msg);
          return;
        }

        //Check if still owning
        $ionicLoading.show({template: constantStrings.processingLoaderMessage});

        if(self.checkIfStillOwningAndNotOffline){
          self.isOwnershipLost = !await self.checkIfStillOwningAndNotOffline();
          if(self.isOwnershipLost){
            $ionicLoading.hide();
            this.modalInstance.remove();
            return;
          }
        }

        Patient.createReferringPhysician(self.rp).then((resp) => {
          $ionicLoading.hide();
          if (resp.status === 200) {
            this.modalInstance.remove();
            self.isAdded = true;
          } else if (resp.message || resp.Message) {
            modalService.showAlert(resp.message || resp.Message);
          }
        }).catch((err) => {
          $ionicLoading.hide();
          if (err.data && err.data.Message) {
            modalService.showAlert(err.data.Message);
          }
        });
      }

      self.joinFields = function (fields) {
        let joinStr = fields.join(', ');
        joinStr = joinStr.replace('RefNum', 'RP ID');
        joinStr = joinStr.replace('OtherPhone', 'Alt Phone');

        return joinStr;
      }

      self.closeWindow = async function () {
        if (self.hasChanged()) {
          const confirmed = await modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?');
          if (confirmed) {
            this.modalInstance.remove();
          }
          return;
        }
        this.modalInstance.remove();
      };

      self.hasChanged = function () {
        let dCopy = _.cloneDeep(_.omit(self.rp));
        let dCopy2 = _.cloneDeep(_.omit(self.rpCopy));

        return !_.isEqual(dCopy, dCopy2);
      };

      self.changeState = function (stateCode) {
        self.rp.City = "";
        self.citiesList = [];
        if (stateCode) {
          self.getCitiesList(stateCode);
        }
        self.rp.Zip = "";
      };

      self.getCitiesList = async function (stateCode) {
        const response = await Patient.getCitiesByState(stateCode).catch(error => {
          let message = error.errorId ? 'Error ID: ' + error.errorId + '. ' : '';
          modalService.showErrorMessage(message + (error.message || error.exception && error.exception.Message));
        });

        self.citiesList = response.data.Cities;

        if (self.rp.City) {
          self.changeCity(self.rp.City);
        }
      };

      self.changeCity = function (city) {
        self.getZipCodesList(city);
      };

      self.getZipCodesList = function (city) {
        self.zipCodesList = [];
        const cityData = self.citiesList.find(item => item.Name === city);
        if (!cityData || !cityData.ZipCodes.includes(self.rp.Zip)) {
          self.rp.Zip = '';
        }
        self.zipCodesList = cityData && cityData.ZipCodes && cityData.ZipCodes.length ? _.map(cityData.ZipCodes, function (zipCode) {
          return { code: zipCode };
        }) : [];
      };

      self.fillStateCity = async function () {
        if (self.rp.Zip.length > 4 && (!self.zipCodesList || !self.zipCodesList.includes(self.rp.Zip))) {
          const res = await Patient.getCitiStateByZip(self.rp.Zip);
          if (res.data && res.data.State && res.data.City) {
            self.rp.City = res.data.City;
            self.rp.State = res.data.State;
            await self.getCitiesList(res.data.State);
            document.activeElement.blur();
          }
        }
      };

      self.formatPhoneValue = (phone) => {
        let phoneNumber = phone;
        let result;
        phoneNumber = phoneNumber.replace(/\D/g, '');
        let operatorCode = phoneNumber.substring(0, 3);
        let firstThreeDigits = phoneNumber.substring(3, 6);
        let lastFourDigits = phoneNumber.substring(6, 10);
        if (operatorCode.length == 3 && firstThreeDigits.length > 0) {
          result = "(" + operatorCode + ") ";
          //if (firstThreeDigits.length > 0) {
          result += firstThreeDigits;
          if (lastFourDigits.length > 0) {
            result += "-" + lastFourDigits;
          }
          //}
        } else {
          result = phoneNumber;
        }
        return result;
      };

      self.validatePhoneNumber = (phoneNumber) => {
        let isValid = true;
        if (phoneNumber !== undefined) {
          let phone = phoneNumber.replace(/\D/g, '');
          if (phone.length > 0 && phone.length !== 10) {
            isValid = false;
          }
        }
        return isValid;
      };

      self.getUdfDefs = async function () {
        let response = await Patient.getUdfDefsByDbf('REFPHY');
        if (response && response.status === 200 && response.data.length > 0) {
          self.showUdf1 = response.data.some(r => r.FieldName === 'U1' && r.Enable && r.TechPad);
          self.showUdf2 = response.data.some(r => r.FieldName === 'U2' && r.Enable && r.TechPad);
        }
      }

    }

    return AddReferringPhysicianDialogModel;
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/models/addReferringPhysicianDialogModel.js